import { createElement } from 'react';

interface FormaToolbarProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  direction?: 'horizontal' | 'vertical';
}

export function FormaToolbar({
  className,
  direction = 'vertical',
  children,
  ...rest
}: FormaToolbarProps) {
  return createElement(
    'forma-toolbar',
    {
      className,
      direction,
      ...rest,
    },
    children
  );
}
